<div class="qr-modal-container">
  <div class="header">
    <h2 class="title">{{ 'liveEvent.result.label.access' | translate }}</h2>
    <mat-icon class="close-btn" (click)="close()">close</mat-icon>
  </div>

  <div class="qr-content" data-cy="qrModel">
    <div class="qr-code-section">
      <div class="qr-code-box">
        <qr-code-preview
          [qr]="qrData?.qr"
          [qrDataUrl]="qrData?.qrDataUrl"
        ></qr-code-preview>
      </div>
      <div class="link-part">{{ shortLinkPrefix }}</div>
    </div>

    <div class="pin-section" (click)="copyPin()">
      <div class="pin-container">
        <div class="pin-char-box">{{ editionPrefix }}</div>
        <div class="pin-char-box hyphen">-</div>
        @for (char of qrData?.pin?.split(''); track $index) {
        <div class="pin-char-box">{{ char }}</div>
        }
      </div>
    </div>

    <div class="actions-section">
      @if (qrData?.openInNewTabText) {
      <a
        class="action-btn"
        [href]="asShortLink(qrData?.pin)"
        target="_blank"
        [matTooltip]="qrData?.openInNewTabText | translate"
      >
        <mat-icon>open_in_new</mat-icon>
        <span class="label">{{ 'course.form.openInNewTab' | translate }}</span>
      </a>
      }

      <div
        class="action-btn"
        (click)="copyWeblink()"
        [matTooltip]="'course.form.clipboardTooltip' | translate"
      >
        <mat-icon>content_copy</mat-icon>
        <span class="label">{{ 'course.form.copyLable' | translate }}</span>
      </div>

      @if (qrData?.invitationLink) {
      <div
        class="action-btn"
        (click)="onInvitationMailUrlClick()"
        [matTooltip]="'course.form.invitationEmailTooltip' | translate"
      >
        <mat-icon>email</mat-icon>
        <span class="label">{{
          'course.form.invitationViaMail' | translate
        }}</span>
      </div>
      } @if (qrData?.embedDialogData) {
      <div
        class="action-btn"
        (click)="embedCourse()"
        [matTooltip]="'course.form.embedTooltip' | translate"
      >
        <mat-icon>code</mat-icon>
        <span class="label">{{ 'course.form.embedAsIFrame' | translate }}</span>
      </div>
      } @if (qrData?.canDownLoadFlyer) {
      <div
        class="action-btn"
        (click)="onGenerateFlyerClick()"
        [matTooltip]="'course.form.downloadFlyerTooltip' | translate"
      >
        <mat-icon>download</mat-icon>
        @if (!generatingFlyer) {
        <span class="label">{{ 'exam.setup.examFlyer' | translate }}</span>
        } @else {
        <span class="label">{{ 'exam.setup.generating' | translate }}</span>
        }
      </div>
      }
    </div>
  </div>
</div>
